howspace.widgets.onEvent('discussion:categorization:failed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    real.notification.show(notification.object.error, 'danger', true);
});
